// src/components/compare/property-compare.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareActionSheetItemTemplateFragment on LodgingCompareActionSheetItemTemplate {\n    button {\n      ...LodgingEGDSButtonFragment\n    }\n    accessibilityLabel {\n      ...LodgingEGDSBasicLocalizedTextFragment\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareActionSheetToolbarFragment on LodgingCompareActionSheetToolbar {\n    collapseAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    expandAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    expandAccessibilityLabel\n    collapseAccessibilityLabel\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareActionSheetFragment on LodgingCompareActionSheet {\n    sheet {\n      ...LodgingEGDSSheetFragment\n    }\n    compareActionPrompt\n    compareActionStatus {\n      ...LodgingEGDSCardinalLocalizedTextFragment\n    }\n    compareAction {\n      ...LodgingEGDSButtonFragment\n    }\n    maxCount\n    itemTemplate {\n      ...LodgingCompareActionSheetItemTemplateFragment\n    }\n    toolbar {\n      ...LodgingCompareActionSheetToolbarFragment\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareBadgeFragment on EGDSStandardBadge {\n    text\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareAttributeFragment on LodgingCompareAttribute {\n    graphic {\n      ...UIGraphicFragment\n    }\n    text {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  fragment LodgingCompareTextItemsFragment on LodgingCompareTextItems {\n    items {\n      ...LodgingCompareAttributeFragment\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareCellContentFragment on LodgingCompareCellContent {\n    __typename\n    ...LodgingEGDSRatingFragment\n    ...LodgingCardGuestRatingFragment\n    ... on LodgingCardPriceSection {\n      priceSummary {\n        ...PropertyPriceFragment\n      }\n      badge {\n        ...LodgingCompareBadgeFragment\n      }\n    }\n    ...LodgingCompareTextItemsFragment\n    ...EGDSBadgeFragment\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareCellFragment on LodgingCompareCell {\n    content {\n      ...LodgingCompareCellContentFragment\n    }\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareRemoveActionFragment on LodgingCompareRemoveAction {\n    propertyId\n    action {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareRowFragment on LodgingCompareRow {\n    cells {\n      ...LodgingCompareCellFragment\n    }\n    theme\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareSectionFragment on LodgingCompareSection {\n    mediaRow {\n      ...LodgingCardMediaSectionFragment\n    }\n    compareRows {\n      ...LodgingCompareRowFragment\n    }\n    viewRow {\n      ...LodgingEGDSButtonFragment\n    }\n    removeRow {\n      ...LodgingCompareRemoveActionFragment\n    }\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment LodgingErrorResponseFragment on LodgingErrorResponse {\n    header\n    body\n    button {\n      ...LodgingEGDSButtonFragment\n    }\n    errorRecoveryButtons {\n      ...LodgingEGDSButtonFragment\n    }\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  query CompareSectionQuery(\n    $context: ContextInput!\n    $criteria: PropertySearchCriteriaInput\n    $propertyIds: [String!]\n    $shoppingContext: ShoppingContextInput\n  ) {\n    propertyCompare(context: $context) {\n      compareSection(criteria: $criteria, propertyIds: $propertyIds, shoppingContext: $shoppingContext) {\n        content {\n          ...LodgingCompareSectionFragment\n        }\n        error {\n          ...LodgingErrorResponseFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment LodgingCompareDialogFragment on EGDSFullScreenDialog {\n    closeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    toolbar {\n      closeText\n      title\n    }\n  }\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  query PropertyCompareQuery($context: ContextInput!) {\n    propertyCompare(context: $context) {\n      actionSheet {\n        ...LodgingCompareActionSheetFragment\n      }\n      dialog {\n        ...LodgingCompareDialogFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
import React19 from "react";
import { gql as gql14, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { clientSideAnalyticsFragment as clientSideAnalyticsFragment2, LodgingEGDSBasicLocalizedText, LodgingEGDSButton as LodgingEGDSButton7, LodgingEGDSCardinalLocalizedText as LodgingEGDSCardinalLocalizedText2, LodgingEGDSIcon as LodgingEGDSIcon2, LodgingEGDSSheet as LodgingEGDSSheet2, lodgingUILinkActionFragment as lodgingUILinkActionFragment2 } from "@shared-ui/lodging-fragments";
// src/components/compare/__private/__fragments/lodging-compare-action-sheet.tsx
import React4, { useCallback as useCallback4, useContext, useEffect, useMemo as useMemo4, useRef, useState } from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { ThumbnailCard as ThumbnailCard2 } from "@egds/react-lodging";
import { useExperiment } from "@shared-ui/experiment-context";
import { defaultState, getPropertyIdFromCardId, isAd as isAd2, LodgingEGDSButton as LodgingEGDSButton2, LodgingEGDSCardinalLocalizedText, MAX_SELECTABLE, OPEN_DIALOG, STATE_FIELD_NAME, useInterpolateCardinalLocalizedText } from "@shared-ui/lodging-fragments";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext } from "@shared-ui/retail-compare-providers";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
// src/components/experiments.ts
var M1_EXPERIMENT = "M1_Web_SDUI_Property_Comparison_Tool_MVP_on_SRP";
var M2_EXPERIMENT = "M2_Property_Comparison_Tool_MLP_Bundled_UI_improvements";
var BEX_SPLIT_VIEW_EXPERIMENT = "Split_View_Side_by_side_BEXG_H";
var VRBO_X_VECTOR_WEB = "Property_Compare_on_VRBO_xVector_Web";
// src/components/compare/__private/__fragments/egds-lodging-sheet.tsx
import React, { useCallback, useMemo } from "react";
import { Sheet } from "@egds/react-lodging";
import { LodgingEGDSSheet, useTrackClientSideAnalytics } from "@shared-ui/lodging-fragments";
var EGDSLodgingSheet = function (_param) {
  var data = _param.data,
    closeCallback = _param.closeCallback,
    openCallback = _param.openCallback,
    props = _object_without_properties(_param, ["data", "closeCallback", "openCallback"]);
  var trackClose = useTrackClientSideAnalytics(data.closeAnalytics);
  var handleClose = useCallback(function () {
    trackClose();
    closeCallback === null || closeCallback === void 0 ? void 0 : closeCallback();
  }, [trackClose, closeCallback]);
  var isVisible = props.isVisible;
  var sheetTransitionsProps = useMemo(function () {
    return {
      isVisible: isVisible,
      openCallback: openCallback,
      closeCallback: handleClose
    };
  }, [isVisible, openCallback, handleClose]);
  return /* @__PURE__ */React.createElement(Sheet, _object_spread_props(_object_spread({}, props), {
    transition: sheetTransitionsProps
  }));
};
LodgingEGDSSheet.displayName = "EGDSLodgingSheet";
// src/components/compare/__private/__fragments/lodging-compare-action-sheet-item-template.tsx
import React2, { useCallback as useCallback2, useMemo as useMemo2 } from "react";
import { gql } from "@apollo/client";
import { EGDSButtonSize } from "@egds/react-core/button";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { ThumbnailCard } from "@egds/react-lodging";
import { isAd, LodgingEGDSButton, REMOVE_COMPARE_PROPERTY, useInterpolateBasicLocalizedText } from "@shared-ui/lodging-fragments";
import { useProvidedState } from "@shared-ui/provided-state-context";
var fragment = gql(_templateObject());
var LodgingCompareActionSheetItemTemplate = function (param) {
  var data = param.data,
    card = param.card;
  var _card_headingSection, _card_mediaSection_gallery;
  var button = data.button,
    accessibilityLabel = data.accessibilityLabel;
  var property = (_card_headingSection = card.headingSection) === null || _card_headingSection === void 0 ? void 0 : _card_headingSection.heading;
  var media = (((_card_mediaSection_gallery = card.mediaSection.gallery) === null || _card_mediaSection_gallery === void 0 ? void 0 : _card_mediaSection_gallery.media[0]) || {}).media;
  var imageSource = (media === null || media === void 0 ? void 0 : media.__typename) === "Image" && typeof media.url === "string" ? media.url : "";
  var values = useMemo2(function () {
    var _accessibilityLabel_models_;
    var _accessibilityLabel_models__source;
    return _define_property({}, (_accessibilityLabel_models__source = (_accessibilityLabel_models_ = accessibilityLabel.models[0]) === null || _accessibilityLabel_models_ === void 0 ? void 0 : _accessibilityLabel_models_.source) !== null && _accessibilityLabel_models__source !== void 0 ? _accessibilityLabel_models__source : "", property !== null && property !== void 0 ? property : "");
  }, [accessibilityLabel, property]);
  var _useInterpolateBasicLocalizedText = _sliced_to_array(useInterpolateBasicLocalizedText(accessibilityLabel, values), 1),
    description = _useInterpolateBasicLocalizedText[0];
  var interpolatedButton = useMemo2(function () {
    if (!(button === null || button === void 0 ? void 0 : button.icon) || !(button === null || button === void 0 ? void 0 : button.analytics)) {
      return button;
    }
    return _object_spread_props(_object_spread({}, button), {
      icon: _object_spread_props(_object_spread({}, button.icon), {
        description: description !== null && description !== void 0 ? description : button.icon.description
      }),
      analytics: _object_spread_props(_object_spread({}, button.analytics), {
        referrerId: isAd(card.mediaSection) ? "".concat(button.analytics.referrerId, ".ad") : button.analytics.referrerId
      })
    });
  }, [button, description]);
  var propertyId = card.id;
  var _useProvidedState = _sliced_to_array(useProvidedState(), 2),
    dispatch = _useProvidedState[1];
  var handleClick = useCallback2(function () {
    if (propertyId) {
      dispatch({
        type: REMOVE_COMPARE_PROPERTY,
        payload: {
          propertyId: propertyId
        }
      });
    }
  }, [propertyId, dispatch]);
  return /* @__PURE__ */React2.createElement(EGDSLayoutGrid, {
    rows: ["18x"]
  }, /* @__PURE__ */React2.createElement(ThumbnailCard, {
    backgroundTheme: "secondary",
    imageUrl: imageSource
  }, /* @__PURE__ */React2.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: {
      left: "zero",
      top: "zero",
      right: "zero",
      bottom: "zero"
    },
    cloneElement: true
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlex, {
    justifyContent: "center",
    alignItems: "center"
  }, interpolatedButton && /* @__PURE__ */React2.createElement(EGDSSpacing, {
    padding: {
      inline: "two"
    }
  }, /* @__PURE__ */React2.createElement(LodgingEGDSButton, {
    data: interpolatedButton,
    size: EGDSButtonSize.SMALL,
    onClick: handleClick
  }))))));
};
LodgingCompareActionSheetItemTemplate.fragment = fragment;
LodgingCompareActionSheetItemTemplate.displayName = "LodgingCompareActionSheetItemTemplate";
// src/components/compare/__private/__fragments/lodging-compare-action-sheet-toolbar.tsx
import React3, { useCallback as useCallback3, useMemo as useMemo3 } from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useTrackClientSideAnalytics as useTrackClientSideAnalytics2 } from "@shared-ui/lodging-fragments";
var fragment2 = gql2(_templateObject1());
var LodgingCompareActionSheetToolbar = function (param) {
  var data = param.data,
    _param_title = param.title,
    title = _param_title === void 0 ? "" : _param_title,
    _param_accessibilityTitle = param.accessibilityTitle,
    accessibilityTitle = _param_accessibilityTitle === void 0 ? "" : _param_accessibilityTitle,
    expanded = param.expanded,
    onToggleExpanded = param.onToggleExpanded,
    announce = param.announce;
  var expandAnalytics = data.expandAnalytics,
    expandAccessibilityLabel = data.expandAccessibilityLabel,
    collapseAnalytics = data.collapseAnalytics,
    collapseAccessibilityLabel = data.collapseAccessibilityLabel;
  var trackExpand = useTrackClientSideAnalytics2(expandAnalytics);
  var trackCollapse = useTrackClientSideAnalytics2(collapseAnalytics);
  var handleNavigationClick = useCallback3(function () {
    var nextExpanded = !expanded;
    onToggleExpanded(nextExpanded);
    if (nextExpanded) {
      trackExpand();
    } else {
      trackCollapse();
    }
  }, [expanded]);
  var navigationContent = useMemo3(function () {
    return {
      onClick: handleNavigationClick,
      navType: expanded ? "expand_down" : "expand_up",
      navIconLabel: expanded ? collapseAccessibilityLabel : expandAccessibilityLabel
    };
  }, [expanded]);
  return /* @__PURE__ */React3.createElement(EGDSToolbar, {
    navigationContent: navigationContent,
    toolbarTitle: title
  }, /* @__PURE__ */React3.createElement(EGDSLayoutPosition2, {
    onClick: handleNavigationClick,
    type: "absolute",
    position: {
      top: "zero",
      left: "twelve",
      right: "zero",
      bottom: "zero"
    },
    cloneElement: true
  }, /* @__PURE__ */React3.createElement("div", null)), /* @__PURE__ */React3.createElement("span", {
    className: "is-visually-hidden",
    "aria-live": announce ? "polite" : void 0
  }, accessibilityTitle));
};
LodgingCompareActionSheetToolbar.fragment = fragment2;
LodgingCompareActionSheetToolbar.displayName = "LodgingCompareActionSheetToolbar";
// src/components/compare/__private/__fragments/lodging-compare-action-sheet.tsx
var fragment3 = gql3(_templateObject2());
var controlGridProperties = {
  alignItems: "center",
  columns: {
    medium: ["1fr", "min-content"]
  },
  space: {
    row: "four",
    column: "six"
  }
};
var m2GridProperties = {
  areas: {
    small: ["items", "cta"],
    medium: ["items cta"]
  },
  columns: {
    medium: ["1fr", "1fr"]
  },
  rows: {
    small: ["18x"]
  },
  space: {
    column: "six",
    row: "four"
  },
  alignItems: "center"
};
var _obj;
var shouldCollapseMap = (_obj = {}, _define_property(_obj, ViewSizes.SMALL, true), _define_property(_obj, ViewSizes.LARGE, false), _obj);
var _obj1;
var thumbnailSpaceMap = (_obj1 = {}, _define_property(_obj1, ViewSizes.SMALL, "two"), _define_property(_obj1, ViewSizes.LARGE, "three"), _obj1);
var _obj2;
var isSplitViewSizeMap = (_obj2 = {}, _define_property(_obj2, ViewSizes.SMALL, false), _define_property(_obj2, ViewSizes.LARGE, true), _obj2);
var SCROLL_THRESHOLD = 5;
var LodgingCompareActionSheet = function (param) {
  var data = param.data;
  var sheet = data.sheet,
    compareActionPrompt = data.compareActionPrompt,
    compareActionStatus = data.compareActionStatus,
    compareAction = data.compareAction,
    toolbar = data.toolbar,
    itemTemplate = data.itemTemplate;
  var _useProvidedState2 = _sliced_to_array(useProvidedState2(), 2),
    state = _useProvidedState2[0],
    dispatch = _useProvidedState2[1];
  var _state_STATE_FIELD_NAME;
  var _ref = (_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState,
    comparePropertyIds = _ref.comparePropertyIds,
    searchResultsProperties = _ref.searchResultsProperties,
    preservedProperties = _ref.preservedProperties;
  var triggerRef = React4.useRef();
  var trackTravelAdsClicks = useCallback4(function () {
    var urls = comparePropertyIds.filter(function (cardId) {
      return cardId.endsWith("-ad");
    }).flatMap(function (cardId) {
      var _card_cardLink;
      var propertyId = cardId.split("-")[0];
      var card = _to_consumable_array(preservedProperties).concat(_to_consumable_array(searchResultsProperties)).find(function (param) {
        var id = param.id,
          mediaSection = param.mediaSection;
        return id === propertyId && isAd2(mediaSection);
      });
      var _card_cardLink_analytics_urls;
      return (_card_cardLink_analytics_urls = card === null || card === void 0 ? void 0 : (_card_cardLink = card.cardLink) === null || _card_cardLink === void 0 ? void 0 : _card_cardLink.analytics.urls) !== null && _card_cardLink_analytics_urls !== void 0 ? _card_cardLink_analytics_urls : null;
    }).filter(function (url) {
      return url;
    });
    urls.forEach(function (url) {
      return navigator.sendBeacon(url);
    });
  }, [comparePropertyIds, searchResultsProperties, preservedProperties]);
  var handleClick = useCallback4(function () {
    dispatch({
      type: OPEN_DIALOG
    });
    trackTravelAdsClicks();
  }, [dispatch, trackTravelAdsClicks]);
  var _useState = _sliced_to_array(useState(false), 2),
    autoCollapsed = _useState[0],
    setAutoCollapsed = _useState[1];
  var _useState1 = _sliced_to_array(useState(false), 2),
    forceCollapsed = _useState1[0],
    setForceCollapsed = _useState1[1];
  var selectedProperties = useMemo4(function () {
    var propertyIds = comparePropertyIds.reduce(function (currentCardIds, nextCardId) {
      var propertyId = getPropertyIdFromCardId(nextCardId);
      return currentCardIds.some(function (cardId) {
        return propertyId === getPropertyIdFromCardId(cardId);
      }) ? currentCardIds : _to_consumable_array(currentCardIds).concat([nextCardId]);
    }, []);
    return propertyIds.map(function (cardId) {
      var _cardId_split = _sliced_to_array(cardId.split("-"), 2),
        propertyId = _cardId_split[0],
        adSuffix = _cardId_split[1];
      var ad = Boolean(adSuffix);
      return _to_consumable_array(preservedProperties).concat(_to_consumable_array(searchResultsProperties)).find(function (param) {
        var id = param.id,
          mediaSection = param.mediaSection;
        return propertyId === id && ad === isAd2(mediaSection);
      });
    }).filter(function (card) {
      return Boolean(card);
    });
  }, [comparePropertyIds, searchResultsProperties, preservedProperties]);
  var _useContext = _sliced_to_array(useContext(CompareAdaptExContext), 2),
    enabled = _useContext[0].enabled,
    setState = _useContext[1];
  var _useExperiment_exposure = useExperiment(BEX_SPLIT_VIEW_EXPERIMENT).exposure,
    bexSplitViewBucket = _useExperiment_exposure.bucket;
  var _useExperiment_exposure1 = useExperiment(VRBO_X_VECTOR_WEB).exposure,
    vrboXVectorWebBucket = _useExperiment_exposure1.bucket;
  var _useExperiment_exposure2 = useExperiment(M2_EXPERIMENT).exposure,
    m2Bucket = _useExperiment_exposure2.bucket;
  var m2BottomSheet = m2Bucket > 0 || vrboXVectorWebBucket > 0;
  var selectedPropertiesCount = selectedProperties.length;
  var _useState2 = _sliced_to_array(useState(selectedPropertiesCount), 2),
    previousSelectedPropertiesCount = _useState2[0],
    setPreviousSelectedPropertiesCount = _useState2[1];
  var maxSelected = useRef(selectedPropertiesCount);
  maxSelected.current = Math.max(maxSelected.current, selectedPropertiesCount);
  var shouldDisplayStatus = m2BottomSheet ? maxSelected.current > 1 : selectedPropertiesCount > 1;
  var values = useMemo4(function () {
    return {
      properties: selectedPropertiesCount
    };
  }, [selectedPropertiesCount]);
  var _useInterpolateCardinalLocalizedText = _sliced_to_array(useInterpolateCardinalLocalizedText(compareActionStatus, values), 2),
    statusTitle = _useInterpolateCardinalLocalizedText[0],
    statusA11yTitle = _useInterpolateCardinalLocalizedText[1];
  var gridProperties = m2BottomSheet ? m2GridProperties : controlGridProperties;
  var expanded = !autoCollapsed && !forceCollapsed;
  var shouldCollapse = useViewportMap(shouldCollapseMap);
  useEffect(function () {
    if (expanded && shouldCollapse) {
      var initialScrollTop = document.documentElement.scrollTop;
      var initialInnerHeight = window.innerHeight;
      var handleScroll = function () {
        var scrollTop = document.documentElement.scrollTop;
        var innerHeight = window.innerHeight;
        if (innerHeight < initialInnerHeight) {
          initialScrollTop = scrollTop;
          initialInnerHeight = innerHeight;
          return;
        }
        initialScrollTop = Math.min(initialScrollTop, scrollTop);
        if (scrollTop - initialScrollTop > SCROLL_THRESHOLD) {
          setAutoCollapsed(true);
        }
      };
      window.addEventListener("scroll", handleScroll);
      return function () {
        return window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [expanded, shouldCollapse]);
  var onToggleExpanded = useCallback4(function (nextExpanded) {
    setAutoCollapsed(!nextExpanded);
    setForceCollapsed(!nextExpanded);
  }, []);
  var handleClose = useCallback4(function () {
    maxSelected.current = 0;
  }, []);
  var thumbnailSpace = useViewportMap(thumbnailSpaceMap);
  var isSplitViewSize = useViewportMap(isSplitViewSizeMap);
  var handleDimensionsChange = useCallback4(function (param) {
    var height = param.height;
    setState(function (previousState) {
      return _object_spread_props(_object_spread({}, previousState), {
        bottomSheetHeight: height
      });
    });
  }, [setState]);
  if (previousSelectedPropertiesCount !== selectedPropertiesCount) {
    setPreviousSelectedPropertiesCount(selectedPropertiesCount);
    if (selectedPropertiesCount > previousSelectedPropertiesCount) {
      setAutoCollapsed(false);
    }
    if (forceCollapsed && (selectedPropertiesCount === MAX_SELECTABLE || selectedPropertiesCount === 0)) {
      setForceCollapsed(false);
    }
    return null;
  }
  if (!sheet) {
    return null;
  }
  return /* @__PURE__ */React4.createElement(EGDSLodgingSheet, {
    data: sheet,
    isVisible: enabled && selectedPropertiesCount > 0,
    type: "bottom",
    triggerRef: triggerRef,
    autoFocus: false,
    closeCallback: handleClose,
    expanded: m2BottomSheet ? expanded : void 0,
    splitView: isSplitViewSize && (bexSplitViewBucket === 1 || vrboXVectorWebBucket > 0),
    onDimensionsChange: handleDimensionsChange
  }, m2BottomSheet && toolbar && /* @__PURE__ */React4.createElement(LodgingCompareActionSheetToolbar, {
    data: toolbar,
    expanded: expanded,
    onToggleExpanded: onToggleExpanded,
    title: statusTitle !== null && statusTitle !== void 0 ? statusTitle : "",
    accessibilityTitle: statusA11yTitle !== null && statusA11yTitle !== void 0 ? statusA11yTitle : "",
    announce: shouldDisplayStatus
  }), /* @__PURE__ */React4.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: "four"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutGrid2, _object_spread({}, gridProperties), /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, null, !shouldDisplayStatus && /* @__PURE__ */React4.createElement("div", {
    "aria-live": selectedPropertiesCount > 0 ? "polite" : void 0
  }, /* @__PURE__ */React4.createElement(EGDSCard, {
    backgroundTheme: "secondary",
    border: true,
    padded: true
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(EGDSIcon, {
    name: "info_outline",
    spotlight: "info"
  }))), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React4.createElement(EGDSText, {
    size: 400
  }, compareActionPrompt))))), !m2BottomSheet && shouldDisplayStatus && compareActionStatus && /* @__PURE__ */React4.createElement("div", {
    "aria-live": "polite"
  }, /* @__PURE__ */React4.createElement(EGDSText, {
    size: 400
  }, /* @__PURE__ */React4.createElement(LodgingEGDSCardinalLocalizedText, {
    data: compareActionStatus,
    values: values
  }))), m2BottomSheet && shouldDisplayStatus && /* @__PURE__ */React4.createElement(EGDSLayoutGrid2, {
    space: thumbnailSpace,
    blockSize: "full_size",
    columns: MAX_SELECTABLE
  }, itemTemplate && selectedProperties.map(function (property) {
    return /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
      key: property.id
    }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(LodgingCompareActionSheetItemTemplate, {
      data: itemTemplate,
      card: property,
      key: property.id
    })));
  }), Array.from({
    length: MAX_SELECTABLE - selectedPropertiesCount
  }, function (_, index) {
    return /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
      key: "item-placeholder-".concat(index)
    }, /* @__PURE__ */React4.createElement(ThumbnailCard2, {
      placeholder: true
    }));
  }))), /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, null, compareAction && /* @__PURE__ */React4.createElement(LodgingEGDSButton2, {
    data: compareAction,
    disabled: selectedPropertiesCount < 2,
    onClick: handleClick,
    isFullWidth: true,
    size: EGDSButtonSize2.LARGE
  }))))));
};
LodgingCompareActionSheet.fragment = fragment3;
LodgingCompareActionSheet.displayName = "LodgingCompareActionSheet";
// src/components/compare/__private/__fragments/lodging-compare-dialog.tsx
import React18, { useCallback as useCallback7, useEffect as useEffect2, useRef as useRef2 } from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { Sheet as Sheet2, Toolbar } from "@egds/react-lodging";
import { useDialog } from "@shared-ui/dialog-context";
import { CLOSE_DIALOG as CLOSE_DIALOG2, defaultState as defaultState2, OPEN_DIALOG as OPEN_DIALOG2, STATE_FIELD_NAME as STATE_FIELD_NAME2, useTrackClientSideAnalytics as useTrackClientSideAnalytics3 } from "@shared-ui/lodging-fragments";
import { useProvidedState as useProvidedState5 } from "@shared-ui/provided-state-context";
import { useViewportMap as useViewportMap4, ViewSizes as ViewSizes4 } from "@shared-ui/viewport-context";
// src/constants.ts
var DIALOG_KEY = "compareDialog";
var DIALOG_ID = "lodging-compare-dialog";
// src/components/compare/__private/__fragments/compare-section.tsx
import React17, { useMemo as useMemo12 } from "react";
import { gql as gql12, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { clientSideAnalyticsFragment, LodgingCardGuestRating as LodgingCardGuestRating2, LodgingCardMediaSection as LodgingCardMediaSection2, LodgingEGDSButton as LodgingEGDSButton6, LodgingEGDSIcon, LodgingEGDSRating as LodgingEGDSRating2, lodgingUILinkActionFragment, SharedUIBadge as SharedUIBadge2, UiGraphic as UiGraphic2 } from "@shared-ui/lodging-fragments";
// src/components/compare/__private/__fragments/lodging-compare-badge.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment4 = gql4(_templateObject3());
var LodgingCompareBadge = function (param) {
  var data = param.data;
  return !data.text ? null :
  // emphasis is being deprecated and will be removed. Use weight="bold" if you need boldness
  /* @__PURE__ */
  React5.createElement(EGDSText2, {
    size: 200,
    weight: "medium",
    theme: "emphasis"
  }, data.text);
};
LodgingCompareBadge.fragment = fragment4;
LodgingCompareBadge.displayName = "LodgingCompareBadge";
// src/components/compare/__private/__fragments/lodging-compare-cell.tsx
import React10, { useMemo as useMemo8 } from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSTableCell, EGDSTableCellBorder, EGDSTableCellPadding } from "@egds/react-core/tables";
// src/providers/lodging-compare-row-provider.tsx
import React6, { createContext, useContext as useContext2, useMemo as useMemo5 } from "react";
var LodgingCompareRowContext = createContext(null);
var LodgingCompareRowProvider = function (param) {
  var theme = param.theme,
    children = param.children;
  var cachedValue = useMemo5(function () {
    return {
      theme: theme
    };
  }, [theme]);
  return /* @__PURE__ */React6.createElement(LodgingCompareRowContext.Provider, {
    value: cachedValue
  }, children);
};
var useLodgingCompareRowContext = function () {
  var context = useContext2(LodgingCompareRowContext);
  if (!context) {
    throw new Error("useLodgingCompareContext can only be used inside LodgingCompareProvider");
  }
  return context;
};
// src/components/compare/__private/__fragments/lodging-compare-cell-content.tsx
import React9 from "react";
import { gql as gql6 } from "@apollo/client";
import { LodgingCardGuestRating, LodgingEGDSRating, PriceSectionPriceSummary, PropertyPriceDocumentNode } from "@shared-ui/lodging-fragments";
// src/components/compare/__private/__fragments/lodging-compare-cell-content-badge.tsx
import React7, { useMemo as useMemo6 } from "react";
import { EGDSBadgeLoyalty, EGDSBadgeLoyaltyThemes } from "@egds/react-core/badge";
import { SharedUIBadge } from "@shared-ui/lodging-fragments";
var LodgingCompareCellContentBadge = function (param) {
  var data = param.data;
  var isLoyaltyTheme = useMemo6(function () {
    return Object.values(EGDSBadgeLoyaltyThemes).includes(data.badgeTheme);
  }, [data.badgeTheme]);
  var _data_text, _data_badgeTheme;
  return isLoyaltyTheme ? /* @__PURE__ */React7.createElement(EGDSBadgeLoyalty, {
    text: (_data_text = data.text) !== null && _data_text !== void 0 ? _data_text : void 0,
    theme: (_data_badgeTheme = data.badgeTheme) !== null && _data_badgeTheme !== void 0 ? _data_badgeTheme : void 0
  }) : /* @__PURE__ */React7.createElement(SharedUIBadge, {
    data: data
  });
};
// src/components/compare/__private/__fragments/lodging-compare-text-items.tsx
import React8, { useMemo as useMemo7 } from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3 } from "@egds/react-core/layout-flex";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSStylizedText, Icon, UiGraphic } from "@shared-ui/lodging-fragments";
var fragment5 = gql5(_templateObject4());
var isIconListItem = function (item) {
  var _item_graphic, _item_text;
  return ((_item_graphic = item.graphic) === null || _item_graphic === void 0 ? void 0 : _item_graphic.__typename) === "Icon" && Boolean((_item_text = item.text) === null || _item_text === void 0 ? void 0 : _item_text.__typename);
};
var TextItem = function (param) {
  var data = param.data,
    margin = param.margin;
  var theme = useLodgingCompareRowContext().theme;
  var spotlightRow = theme === "SPOTLIGHT" /* SPOTLIGHT */;
  var content = useMemo7(function () {
    if (Array.isArray(data)) {
      var _data_;
      return /* @__PURE__ */React8.createElement(EGDSList, {
        bullet: "icon-standard",
        size: ((_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.text.size) === "200" ? 3 : void 0,
        spacing: false
      }, data.map(function (item, index) {
        return /* @__PURE__ */React8.createElement(EGDSListItem, {
          key: index
        }, spotlightRow ? /* @__PURE__ */React8.createElement(EGDSLayoutFlex3, {
          alignItems: "center"
        }, /* @__PURE__ */React8.createElement(Icon, {
          data: item.graphic
        })) : /* @__PURE__ */React8.createElement(Icon, {
          data: item.graphic
        }), /* @__PURE__ */React8.createElement(EGDSStylizedText, {
          inline: true,
          data: item.text
        }));
      }));
    }
    if (data.graphic && data.text) {
      return /* @__PURE__ */React8.createElement("div", null, /* @__PURE__ */React8.createElement(UiGraphic, {
        data: data.graphic
      }), /* @__PURE__ */React8.createElement(EGDSStylizedText, {
        inline: true,
        data: data.text
      }));
    }
    if (data.graphic) {
      return /* @__PURE__ */React8.createElement(UiGraphic, {
        data: data.graphic
      });
    }
    if (data.text) {
      return /* @__PURE__ */React8.createElement(EGDSStylizedText, {
        data: data.text
      });
    }
    return null;
  }, [data]);
  return margin && content ? /* @__PURE__ */React8.createElement(EGDSSpacing3, {
    margin: margin
  }, content) : content;
};
var topMargin = {
  blockstart: "two"
};
var LodgingCompareTextItems = function (param) {
  var data = param.data;
  var items = data.items;
  var textItemFragments = useMemo7(function () {
    return (items || []).reduce(function (acc, item) {
      if (!item) {
        return acc;
      }
      if (isIconListItem(item)) {
        var lastItem = acc[acc.length - 1];
        if (Array.isArray(lastItem)) {
          lastItem.push(item);
        } else {
          acc.push([item]);
        }
      } else {
        acc.push(item);
      }
      return acc;
    }, []);
  }, [items]);
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, textItemFragments.map(function (textItemFragment, index) {
    var margin = index > 0 && Array.isArray(textItemFragment) !== Array.isArray(textItemFragment[index - 1]) ? topMargin : void 0;
    return /* @__PURE__ */React8.createElement(TextItem, {
      data: textItemFragment,
      key: index,
      margin: margin
    });
  }));
};
LodgingCompareTextItems.fragment = fragment5;
LodgingCompareTextItems.displayName = "LodgingCompareTextItems";
// src/components/compare/__private/__fragments/lodging-compare-cell-content.tsx
var fragment6 = gql6(_templateObject5(), PropertyPriceDocumentNode);
var LodgingCompareCellContent = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "EGDSIconRating":
      return /* @__PURE__ */React9.createElement(LodgingEGDSRating, {
        data: data
      });
    case "LodgingCompareTextItems":
      return /* @__PURE__ */React9.createElement(LodgingCompareTextItems, {
        data: data
      });
    case "LodgingCardPhrase":
      return /* @__PURE__ */React9.createElement(LodgingCardGuestRating, {
        data: data
      });
    case "LodgingCardPriceSection":
      {
        return /* @__PURE__ */React9.createElement(React9.Fragment, null, data.badge && /* @__PURE__ */React9.createElement(LodgingCompareBadge, {
          data: data.badge
        }), /* @__PURE__ */React9.createElement(PriceSectionPriceSummary, {
          priceSummary: data.priceSummary,
          flexAlignment: "start"
        }));
      }
    case "EGDSStandardBadge":
      return /* @__PURE__ */React9.createElement(LodgingCompareCellContentBadge, {
        data: data
      });
    default:
      return null;
  }
};
LodgingCompareCellContent.fragment = fragment6;
LodgingCompareCellContent.displayName = "LodgingCompareCellContent";
// src/components/compare/__private/__fragments/lodging-compare-cell.tsx
var fragment7 = gql7(_templateObject6());
var PADDING = "three";
var computeBorder = function (combineNextRow) {
  return combineNextRow ? EGDSTableCellBorder.vertical : [EGDSTableCellBorder.horizontal, EGDSTableCellBorder.vertical];
};
var computePadding = function (combineNextRow, combinePreviousRow) {
  return combineNextRow || combinePreviousRow ? {
    inline: PADDING,
    blockstart: combinePreviousRow ? void 0 : PADDING,
    blockend: combineNextRow ? void 0 : PADDING
  } : void 0;
};
var LodgingCompareCell = function (param) {
  var data = param.data,
    combinePreviousRow = param.combinePreviousRow;
  var theme = useLodgingCompareRowContext().theme;
  var combineNextRow = theme === "COMBINE_NEXT" /* COMBINE_NEXT */;
  var spotlightRow = theme === "SPOTLIGHT" /* SPOTLIGHT */;
  var content = data.content;
  var border = useMemo8(function () {
    return computeBorder(combineNextRow || spotlightRow);
  }, [combineNextRow, spotlightRow]);
  var padding = useMemo8(function () {
    return computePadding(combineNextRow, combinePreviousRow);
  }, [combineNextRow, combinePreviousRow]);
  var cellContent = content && /* @__PURE__ */React10.createElement(LodgingCompareCellContent, {
    data: content
  });
  return /* @__PURE__ */React10.createElement(EGDSTableCell, {
    border: border,
    align: (content === null || content === void 0 ? void 0 : content.__typename) === "LodgingCardPriceSection" ? {
      vertical: "bottom"
    } : {
      vertical: "top"
    },
    padding: padding ? EGDSTableCellPadding.zero : void 0
  }, padding ? /* @__PURE__ */React10.createElement(EGDSSpacing4, {
    padding: padding
  }, /* @__PURE__ */React10.createElement("div", null, cellContent)) : cellContent);
};
LodgingCompareCell.fragment = fragment7;
LodgingCompareCell.displayName = "LodgingCompareCell";
// src/components/compare/__private/__fragments/lodging-compare-loading.tsx
import React11, { useMemo as useMemo9 } from "react";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSTable, EGDSTableBody, EGDSTableCell as EGDSTableCell2, EGDSTableCellBorder as EGDSTableCellBorder2, EGDSTableCellPadding as EGDSTableCellPadding2, EGDSTableRow } from "@egds/react-core/tables";
import { getPropertyIdFromCardId as getPropertyIdFromCardId2 } from "@shared-ui/lodging-fragments";
import { useViewportMap as useViewportMap2, ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
var rows = new Array(5).fill(null);
var _obj3;
var spacingPropsMap = (_obj3 = {}, _define_property(_obj3, ViewSizes2.SMALL, {
  padding: {
    inline: "six"
  }
}), _define_property(_obj3, ViewSizes2.LARGE, {
  padding: {
    inline: "three"
  }
}), _obj3);
var LodgingCompareLoading = function (param) {
  var propertyIds = param.propertyIds;
  var columns = useMemo9(function () {
    return new Array(_to_consumable_array(new Set((propertyIds !== null && propertyIds !== void 0 ? propertyIds : []).map(getPropertyIdFromCardId2))).length).fill(null);
  }, [propertyIds]);
  var spacingProps = useViewportMap2(spacingPropsMap);
  return /* @__PURE__ */React11.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, {
    grow: 1
  }, /* @__PURE__ */React11.createElement("div", null)), /* @__PURE__ */React11.createElement(EGDSSpacing5, _object_spread({}, spacingProps), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, {
    minWidth: "zero"
  }, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(EGDSTable, {
    overflow: false
  }, /* @__PURE__ */React11.createElement(EGDSTableBody, null, /* @__PURE__ */React11.createElement(React11.Fragment, null, /* @__PURE__ */React11.createElement(EGDSTableRow, null, columns.map(function (_, index) {
    return /* @__PURE__ */React11.createElement(EGDSTableCell2, {
      key: index,
      border: EGDSTableCellBorder2.vertical,
      padding: EGDSTableCellPadding2.zero
    }, /* @__PURE__ */React11.createElement(EGDSFigure, {
      ratio: EGDSFigureAspectRatioType.R1_1
    }, /* @__PURE__ */React11.createElement(EGDSBlockSkeleton, null)));
  })), /* @__PURE__ */React11.createElement(EGDSTableRow, null, columns.map(function (__, index) {
    return /* @__PURE__ */React11.createElement(EGDSTableCell2, {
      key: index,
      padding: EGDSTableCellPadding2.zero
    }, /* @__PURE__ */React11.createElement(EGDSSpacing5, {
      padding: {
        blockend: "four",
        blockstart: "three"
      }
    }, /* @__PURE__ */React11.createElement(EGDSLayoutGrid3, {
      columns: ["minmax(154px, 154px)"]
    }, /* @__PURE__ */React11.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(EGDSSpacing5, {
      margin: {
        blockend: "two"
      }
    }, /* @__PURE__ */React11.createElement(EGDSLineSkeleton, {
      animation: false
    })), /* @__PURE__ */React11.createElement(EGDSLineSkeleton, {
      type: "secondary",
      animation: false
    }))))));
  })), rows.map(function (_, rowIndex) {
    return /* @__PURE__ */React11.createElement(EGDSTableRow, {
      key: rowIndex
    }, columns.map(function (__, index) {
      return /* @__PURE__ */React11.createElement(EGDSTableCell2, {
        key: index,
        padding: "zero"
      }, /* @__PURE__ */React11.createElement(EGDSSpacing5, {
        margin: {
          blockend: "four",
          blockstart: "four"
        }
      }, /* @__PURE__ */React11.createElement(EGDSLineSkeleton, {
        type: "secondary",
        animation: false
      })));
    }));
  }))))))), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, {
    grow: 1
  }, /* @__PURE__ */React11.createElement("div", null)));
};
// src/components/compare/__private/__fragments/lodging-compare-remove-action.tsx
import React12, { useCallback as useCallback5 } from "react";
import { gql as gql8 } from "@apollo/client";
import { LodgingEGDSButton as LodgingEGDSButton3, REMOVE_COMPARE_PROPERTY as REMOVE_COMPARE_PROPERTY2 } from "@shared-ui/lodging-fragments";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
var fragment8 = gql8(_templateObject7());
var LodgingCompareRemoveAction = function (param) {
  var data = param.data;
  var propertyId = data.propertyId;
  var _useProvidedState3 = _sliced_to_array(useProvidedState3(), 2),
    dispatch = _useProvidedState3[1];
  var handleClick = useCallback5(function () {
    if (propertyId) {
      dispatch({
        type: REMOVE_COMPARE_PROPERTY2,
        payload: {
          propertyId: propertyId
        }
      });
    }
  }, [propertyId, dispatch]);
  return data.action && /* @__PURE__ */React12.createElement(LodgingEGDSButton3, {
    data: data.action,
    onClick: handleClick
  });
};
LodgingCompareRemoveAction.fragment = fragment8;
LodgingCompareRemoveAction.displayName = "LodgingCompareRemoveAction";
// src/components/compare/__private/__fragments/lodging-compare-row.tsx
import React14 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSTableCell as EGDSTableCell4 } from "@egds/react-core/tables";
import { TableRow } from "@egds/react-lodging";
// src/components/compare/__private/__fragments/lodging-compare-cell-header.tsx
import React13, { useMemo as useMemo10 } from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSTableCell as EGDSTableCell3, EGDSTableCellHeaderScope, EGDSTableCellPadding as EGDSTableCellPadding3, EGDSTableCellTag } from "@egds/react-core/tables";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var LodgingCompareCellHeader = function (param) {
  var content = param.data.content;
  var theme = useLodgingCompareRowContext().theme;
  var combineNextRow = theme === "COMBINE_NEXT" /* COMBINE_NEXT */;
  var border = useMemo10(function () {
    return computeBorder(combineNextRow);
  }, [combineNextRow]);
  var padding = useMemo10(function () {
    return computePadding(combineNextRow, false);
  }, [combineNextRow]);
  return /* @__PURE__ */React13.createElement(EGDSTableCell3, {
    border: border,
    tag: EGDSTableCellTag.header,
    scope: EGDSTableCellHeaderScope.column,
    padding: padding ? EGDSTableCellPadding3.zero : void 0,
    align: {
      vertical: "top",
      horizontal: "leading"
    }
  }, /* @__PURE__ */React13.createElement(EGDSSpacing6, {
    padding: padding
  }, /* @__PURE__ */React13.createElement(EGDSLayoutGrid4, {
    columns: ["minmax(130px, 130px)"]
  }, /* @__PURE__ */React13.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React13.createElement(EGDSSpacing6, null, /* @__PURE__ */React13.createElement(EGDSText3, {
    whiteSpace: "normal"
  }, content && /* @__PURE__ */React13.createElement(LodgingCompareCellContent, {
    data: content
  })))))));
};
LodgingCompareCellHeader.displayName = "LodgingCompareCellHeader";
// src/components/compare/__private/__fragments/lodging-compare-row.tsx
var fragment9 = gql9(_templateObject8());
var LodgingCompareRow = function (param) {
  var combinePreviousRow = param.combinePreviousRow,
    headingRow = param.headingRow,
    getKey = param.getKey,
    data = param.data;
  var cells = data.cells;
  var theme = useLodgingCompareRowContext().theme;
  var spotlightRow = theme === "SPOTLIGHT" /* SPOTLIGHT */;
  return /* @__PURE__ */React14.createElement(TableRow, {
    spotlightRow: spotlightRow
  }, cells.map(function (cell, index) {
    var key = getKey(index);
    if (!cell) {
      return /* @__PURE__ */React14.createElement(EGDSTableCell4, {
        key: key
      });
    }
    return headingRow ? /* @__PURE__ */React14.createElement(LodgingCompareCellHeader, {
      key: key,
      data: cell
    }) : /* @__PURE__ */React14.createElement(LodgingCompareCell, {
      key: key,
      data: cell,
      combinePreviousRow: combinePreviousRow
    });
  }));
};
LodgingCompareRow.fragment = fragment9;
LodgingCompareRow.displayName = "LodgingCompareRow";
// src/components/compare/__private/__fragments/lodging-compare-section.tsx
import React15, { useMemo as useMemo11 } from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSTable as EGDSTable2, EGDSTableBody as EGDSTableBody2, EGDSTableCell as EGDSTableCell5, EGDSTableCellBorder as EGDSTableCellBorder3, EGDSTableCellPadding as EGDSTableCellPadding4, EGDSTableRow as EGDSTableRow2 } from "@egds/react-core/tables";
import { getPropertyIdFromCardId as getPropertyIdFromCardId3, LodgingCardMediaSection, LodgingCardView, LodgingEGDSButton as LodgingEGDSButton4 } from "@shared-ui/lodging-fragments";
import { useViewportMap as useViewportMap3, ViewSizes as ViewSizes3 } from "@shared-ui/viewport-context";
var fragment10 = gql10(_templateObject9());
var hasData = function (array) {
  return Boolean((array === null || array === void 0 ? void 0 : array.length) && !array.every(function (value) {
    return value === null;
  }));
};
var hasPropertyId = function (value) {
  var _value_propertyId;
  return ((_value_propertyId = value === null || value === void 0 ? void 0 : value.propertyId) !== null && _value_propertyId !== void 0 ? _value_propertyId : null) !== null;
};
var emptyStrings = /* @__PURE__ */new Set(["", "-"]);
var isEmptyCell = function (cell) {
  var _cell_content, _cell_content_items, _cell_content_items__text, _cell_content_items_;
  return (cell === null || cell === void 0 ? void 0 : (_cell_content = cell.content) === null || _cell_content === void 0 ? void 0 : _cell_content.__typename) === "LodgingCompareTextItems" && ((_cell_content_items = cell.content.items) === null || _cell_content_items === void 0 ? void 0 : _cell_content_items.length) === 1 && emptyStrings.has((_cell_content_items_ = cell.content.items[0]) === null || _cell_content_items_ === void 0 ? void 0 : (_cell_content_items__text = _cell_content_items_.text) === null || _cell_content_items__text === void 0 ? void 0 : _cell_content_items__text.text);
};
var isEmptyRow = function (row) {
  return row === null || row === void 0 ? void 0 : row.cells.every(isEmptyCell);
};
var _obj4;
var spacingPropsMap2 = (_obj4 = {}, _define_property(_obj4, ViewSizes3.SMALL, {
  padding: {
    inline: "six"
  }
}), _define_property(_obj4, ViewSizes3.LARGE, {
  padding: {
    inline: "three"
  }
}), _obj4);
var combinePreviousRowTypes = /* @__PURE__ */new Set(["EGDSIconRating", "EGDSStandardBadge"]);
var LodgingCompareSection = function (param) {
  var propertyIds = param.propertyIds,
    data = param.data;
  var _useMemo11 = useMemo11(function () {
      var _data_removeRow, _data_mediaRow, _data_viewRow;
      if (!(((_data_removeRow = data.removeRow) === null || _data_removeRow === void 0 ? void 0 : _data_removeRow.length) && data.removeRow.every(hasPropertyId))) {
        return data;
      }
      var selectedCardIds = new Set((propertyIds !== null && propertyIds !== void 0 ? propertyIds : []).map(getPropertyIdFromCardId3));
      var selectedIndexes = new Set(data.removeRow.reduce(function (acc, action, index) {
        return (action === null || action === void 0 ? void 0 : action.propertyId) && selectedCardIds.has(action.propertyId) ? _to_consumable_array(acc).concat([index]) : acc;
      }, []));
      var isSelected = function (_, index) {
        return selectedIndexes.has(index);
      };
      var _data_mediaRow_filter, _data_viewRow_filter, _data_removeRow_filter;
      var filteredData = _object_spread_props(_object_spread({}, data), {
        mediaRow: (_data_mediaRow_filter = (_data_mediaRow = data.mediaRow) === null || _data_mediaRow === void 0 ? void 0 : _data_mediaRow.filter(isSelected)) !== null && _data_mediaRow_filter !== void 0 ? _data_mediaRow_filter : null,
        compareRows: data.compareRows.map(function (row) {
          return row && _object_spread_props(_object_spread({}, row), {
            cells: row.cells.filter(isSelected)
          });
        }).reduce(function (rows2, row) {
          if (isEmptyRow(row)) {
            var lastRow = rows2[rows2.length - 1];
            if ((lastRow === null || lastRow === void 0 ? void 0 : lastRow.theme) === "COMBINE_NEXT" /* COMBINE_NEXT */ && (row === null || row === void 0 ? void 0 : row.theme) === "STANDARD" /* STANDARD */) {
              return _to_consumable_array(rows2.slice(0, -1)).concat([_object_spread_props(_object_spread({}, lastRow), {
                theme: "STANDARD" /* STANDARD */
              })]);
            }
            return rows2;
          }
          return _to_consumable_array(rows2).concat([row]);
        }, []),
        viewRow: (_data_viewRow_filter = (_data_viewRow = data.viewRow) === null || _data_viewRow === void 0 ? void 0 : _data_viewRow.filter(isSelected)) !== null && _data_viewRow_filter !== void 0 ? _data_viewRow_filter : null,
        removeRow: (_data_removeRow_filter = data.removeRow.filter(isSelected)) !== null && _data_removeRow_filter !== void 0 ? _data_removeRow_filter : null
      });
      return filteredData;
    }, [propertyIds, data]),
    mediaRow = _useMemo11.mediaRow,
    compareRows = _useMemo11.compareRows,
    viewRow = _useMemo11.viewRow,
    removeRow = _useMemo11.removeRow;
  var _removeRow_map;
  var keys = (_removeRow_map = removeRow === null || removeRow === void 0 ? void 0 : removeRow.map(function (action, index) {
    var _action_propertyId;
    return (_action_propertyId = action === null || action === void 0 ? void 0 : action.propertyId) !== null && _action_propertyId !== void 0 ? _action_propertyId : index;
  })) !== null && _removeRow_map !== void 0 ? _removeRow_map : [];
  var getKey = function (index) {
    var _keys_index;
    return (_keys_index = keys[index]) !== null && _keys_index !== void 0 ? _keys_index : index;
  };
  var spacingProps = useViewportMap3(spacingPropsMap2);
  var headingRowIndex = compareRows.findIndex(function (row) {
    return (row === null || row === void 0 ? void 0 : row.theme) !== "SPOTLIGHT" /* SPOTLIGHT */;
  });
  return /* @__PURE__ */React15.createElement(EGDSLayoutFlex5, null, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React15.createElement("div", null)), /* @__PURE__ */React15.createElement(EGDSSpacing7, _object_spread({}, spacingProps), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, {
    minWidth: "zero"
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSTable2, {
    border: true,
    overflow: false
  }, /* @__PURE__ */React15.createElement(EGDSTableBody2, null, /* @__PURE__ */React15.createElement(React15.Fragment, null, hasData(mediaRow) && /* @__PURE__ */React15.createElement(EGDSTableRow2, null, mediaRow.map(function (section, index) {
    return /* @__PURE__ */React15.createElement(EGDSTableCell5, {
      key: getKey(index),
      border: [EGDSTableCellBorder3.horizontal, EGDSTableCellBorder3.vertical],
      padding: EGDSTableCellPadding4.zero
    }, section && /* @__PURE__ */React15.createElement(LodgingCardMediaSection, {
      data: section,
      propertyId: propertyIds === null || propertyIds === void 0 ? void 0 : propertyIds[index],
      view: LodgingCardView.RESPONSIVE,
      imageRatio: EGDSFigureAspectRatioType2.R1_1
    }));
  })), compareRows.map(function (row, rowIndex) {
    var _compareRows_;
    if (!(row && hasData(row.cells))) {
      return null;
    }
    var combinePreviousRow = ((_compareRows_ = compareRows[rowIndex - 1]) === null || _compareRows_ === void 0 ? void 0 : _compareRows_.theme) === "COMBINE_NEXT" /* COMBINE_NEXT */ && row.cells.some(function (cell) {
      var _cell_content;
      return combinePreviousRowTypes.has(cell === null || cell === void 0 ? void 0 : (_cell_content = cell.content) === null || _cell_content === void 0 ? void 0 : _cell_content.__typename);
    });
    return /* @__PURE__ */React15.createElement(LodgingCompareRowProvider, {
      key: rowIndex,
      theme: row.theme
    }, /* @__PURE__ */React15.createElement(LodgingCompareRow, {
      data: row,
      getKey: getKey,
      combinePreviousRow: combinePreviousRow,
      headingRow: rowIndex === headingRowIndex
    }));
  }), hasData(viewRow) && /* @__PURE__ */React15.createElement(EGDSTableRow2, null, viewRow.map(function (buttonData, index) {
    return /* @__PURE__ */React15.createElement(EGDSTableCell5, {
      key: getKey(index),
      border: [EGDSTableCellBorder3.horizontal, EGDSTableCellBorder3.vertical]
    }, buttonData && /* @__PURE__ */React15.createElement(LodgingEGDSButton4, {
      data: buttonData,
      isFullWidth: true
    }));
  })), hasData(removeRow) && /* @__PURE__ */React15.createElement(EGDSTableRow2, null, removeRow.map(function (removeData, index) {
    return /* @__PURE__ */React15.createElement(EGDSTableCell5, {
      align: {
        horizontal: "center"
      },
      key: getKey(index),
      border: [EGDSTableCellBorder3.horizontal, EGDSTableCellBorder3.vertical]
    }, removeData && /* @__PURE__ */React15.createElement(LodgingCompareRemoveAction, {
      data: removeData
    }));
  })))))))), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React15.createElement("div", null)));
};
LodgingCompareSection.fragment = fragment10;
LodgingCompareSection.displayName = "LodgingCompareSection";
// src/components/compare/__private/__fragments/lodging-error-response.tsx
import React16, { useCallback as useCallback6 } from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { CLOSE_DIALOG, LodgingEGDSButton as LodgingEGDSButton5 } from "@shared-ui/lodging-fragments";
import { useProvidedState as useProvidedState4 } from "@shared-ui/provided-state-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment11 = gql11(_templateObject10());
var LodgingErrorResponse = function (param) {
  var data = param.data;
  var button = data.button,
    header = data.header,
    body = data.body,
    errorRecoveryButtons = data.errorRecoveryButtons;
  var _useProvidedState4 = _sliced_to_array(useProvidedState4(), 2),
    dispatch = _useProvidedState4[1];
  var closeDialog = useCallback6(function () {
    dispatch({
      type: CLOSE_DIALOG
    });
    window._qHasUsedPropertyCompare = true;
  }, [dispatch]);
  var handlePrimaryButtonClick = useCallback6(function () {
    if (button.egdsElementId === "lodging-property-compare-error-button-close") {
      closeDialog();
    } else {
      window.location.reload();
    }
  }, [button.egdsElementId, closeDialog]);
  return /* @__PURE__ */React16.createElement(EGDSSpacing8, {
    margin: {
      inline: "six"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlex6, {
    direction: "column",
    blockSize: "full_size",
    alignItems: "center"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React16.createElement(EGDSHeading, {
    size: 5
  }, header)), /* @__PURE__ */React16.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React16.createElement(EGDSText4, {
    size: 300,
    align: "center"
  }, body))), /* @__PURE__ */React16.createElement(Viewport, null, /* @__PURE__ */React16.createElement(ViewSmall, null, /* @__PURE__ */React16.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React16.createElement(LodgingEGDSButton5, {
    data: button,
    isFullWidth: true,
    onClick: handlePrimaryButtonClick
  })))), /* @__PURE__ */React16.createElement(ViewMedium, null, /* @__PURE__ */React16.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React16.createElement(LodgingEGDSButton5, {
    data: button,
    onClick: handlePrimaryButtonClick
  }))))), (errorRecoveryButtons === null || errorRecoveryButtons === void 0 ? void 0 : errorRecoveryButtons[0]) ? /* @__PURE__ */React16.createElement(Viewport, null, /* @__PURE__ */React16.createElement(ViewSmall, null, /* @__PURE__ */React16.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React16.createElement(LodgingEGDSButton5, {
    data: errorRecoveryButtons[0],
    onClick: closeDialog,
    isFullWidth: true
  })))), /* @__PURE__ */React16.createElement(ViewMedium, null, /* @__PURE__ */React16.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React16.createElement(LodgingEGDSButton5, {
    data: errorRecoveryButtons[0],
    onClick: closeDialog
  }))))) : null));
};
LodgingErrorResponse.fragment = fragment11;
LodgingErrorResponse.displayName = "LodgingErrorResponse";
// src/components/compare/__private/__fragments/compare-section.tsx
var __Query = gql12(_templateObject11(), LodgingCompareSection.fragment, LodgingCardMediaSection2.fragment, LodgingCompareCell.fragment, LodgingCompareCellContent.fragment, LodgingEGDSRating2.fragment, LodgingCardGuestRating2.fragment, LodgingCompareTextItems.fragment, LodgingCompareBadge.fragment, UiGraphic2.fragment, LodgingEGDSIcon.fragment, LodgingEGDSButton6.fragment, clientSideAnalyticsFragment, lodgingUILinkActionFragment, LodgingCompareRemoveAction.fragment, LodgingErrorResponse.fragment, SharedUIBadge2.fragment, LodgingCompareRow.fragment);
var CompareSection = function (props) {
  var _data_propertyCompare;
  var inputs = props.inputs,
    skipSsr = props.skipSsr;
  var context = useBexApi().context;
  var variables = useMemo12(function () {
    return _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
  }, []);
  var data = useQuery(__Query, {
    variables: variables,
    ssr: !skipSsr
  }).data;
  var _data_propertyCompare_compareSection;
  var _ref = (_data_propertyCompare_compareSection = data === null || data === void 0 ? void 0 : (_data_propertyCompare = data.propertyCompare) === null || _data_propertyCompare === void 0 ? void 0 : _data_propertyCompare.compareSection) !== null && _data_propertyCompare_compareSection !== void 0 ? _data_propertyCompare_compareSection : {},
    content = _ref.content,
    error = _ref.error;
  if (error) {
    return /* @__PURE__ */React17.createElement(LodgingErrorResponse, {
      data: error
    });
  }
  if (content) {
    return /* @__PURE__ */React17.createElement(LodgingCompareSection, {
      data: content,
      propertyIds: inputs.propertyIds
    });
  }
  return /* @__PURE__ */React17.createElement(LodgingCompareLoading, {
    propertyIds: inputs.propertyIds
  });
};
CompareSection.displayName = "CompareSection";
// src/components/compare/__private/__fragments/lodging-compare-dialog.tsx
var fragment12 = gql13(_templateObject12());
var _obj5;
var sheetPropsMap = (_obj5 = {}, _define_property(_obj5, ViewSizes4.SMALL, {
  type: "full"
}), _define_property(_obj5, ViewSizes4.LARGE, {
  type: "centered",
  minWidth: 804,
  maxWidth: 804
}), _obj5);
var _obj6;
var spacingPropsMap3 = (_obj6 = {}, _define_property(_obj6, ViewSizes4.SMALL, {
  padding: {
    block: "six"
  }
}), _define_property(_obj6, ViewSizes4.LARGE, {
  padding: {
    blockstart: "three",
    blockend: "six"
  }
}), _obj6);
var _obj7;
var shouldHaveBottomBorderMap = (_obj7 = {}, _define_property(_obj7, ViewSizes4.SMALL, true), _define_property(_obj7, ViewSizes4.LARGE, false), _obj7);
var LodgingCompareDialog = function (param) {
  var _param_data = param.data,
    closeAnalytics = _param_data.closeAnalytics,
    toolbar = _param_data.toolbar,
    inputs = param.inputs;
  var trackClose = useTrackClientSideAnalytics3(closeAnalytics);
  var triggerRef = useRef2(null);
  var _useDialog = _sliced_to_array(useDialog(DIALOG_ID, DIALOG_KEY), 3),
    hookIsOpen = _useDialog[0],
    DialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var _useProvidedState5 = _sliced_to_array(useProvidedState5(), 2),
    state = _useProvidedState5[0],
    dispatch = _useProvidedState5[1];
  var _state_STATE_FIELD_NAME2;
  var _ref = (_state_STATE_FIELD_NAME2 = state[STATE_FIELD_NAME2]) !== null && _state_STATE_FIELD_NAME2 !== void 0 ? _state_STATE_FIELD_NAME2 : defaultState2,
    stateIsOpen = _ref.isDialogOpen,
    comparePropertyIds = _ref.comparePropertyIds,
    deepLinkDialogPropertyIds = _ref.deepLinkDialogPropertyIds;
  var isOpen = useRef2(false);
  var shouldHaveBottomBorder = useViewportMap4(shouldHaveBottomBorderMap);
  useEffect2(function () {
    if (stateIsOpen !== isOpen.current) {
      if (stateIsOpen) {
        DialogActions.openDialog();
      } else {
        trackClose();
        DialogActions.closeDialog();
      }
      isOpen.current = stateIsOpen;
    } else if (hookIsOpen !== isOpen.current) {
      dispatch({
        type: hookIsOpen ? OPEN_DIALOG2 : CLOSE_DIALOG2
      });
      isOpen.current = hookIsOpen;
    }
  }, [stateIsOpen, hookIsOpen]);
  var closeDialog = useCallback7(function () {
    dispatch({
      type: CLOSE_DIALOG2
    });
    window._qHasUsedPropertyCompare = true;
  }, [dispatch]);
  var propertyIds = deepLinkDialogPropertyIds.length ? deepLinkDialogPropertyIds : comparePropertyIds;
  var sheetProps = useViewportMap4(sheetPropsMap);
  var spacingProps = useViewportMap4(spacingPropsMap3);
  var _toolbar_closeText;
  return /* @__PURE__ */React18.createElement(EGDSSheetTransition, {
    isVisible: hookIsOpen
  }, /* @__PURE__ */React18.createElement(DialogComponent, null, /* @__PURE__ */React18.createElement(Sheet2, _object_spread({
    isVisible: hookIsOpen,
    triggerRef: triggerRef
  }, sheetProps), /* @__PURE__ */React18.createElement(Toolbar, {
    bottomBorder: shouldHaveBottomBorder,
    toolbarTitle: toolbar.title,
    navigationContent: {
      onClick: closeDialog,
      navIconLabel: (_toolbar_closeText = toolbar.closeText) !== null && _toolbar_closeText !== void 0 ? _toolbar_closeText : void 0
    }
  }), /* @__PURE__ */React18.createElement(EGDSSheetContent2, {
    padded: false
  }, /* @__PURE__ */React18.createElement(EGDSSpacing9, _object_spread({}, spacingProps), /* @__PURE__ */React18.createElement("div", null, /* @__PURE__ */React18.createElement(CompareSection, {
    inputs: _object_spread_props(_object_spread({}, inputs), {
      propertyIds: propertyIds
    })
  })))))));
};
LodgingCompareDialog.fragment = fragment12;
LodgingCompareDialog.displayName = "LodgingCompareDialog";
// src/components/compare/property-compare.tsx
var __Query2 = gql14(_templateObject13(), LodgingCompareActionSheet.fragment, LodgingEGDSSheet2.fragment, clientSideAnalyticsFragment2, LodgingEGDSCardinalLocalizedText2.fragment, LodgingEGDSIcon2.fragment, LodgingEGDSButton7.fragment, LodgingCompareDialog.fragment, lodgingUILinkActionFragment2, LodgingEGDSBasicLocalizedText.fragment, LodgingCompareActionSheetToolbar.fragment, LodgingCompareActionSheetItemTemplate.fragment);
var PropertyCompare = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr;
  var context = useBexApi2().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery2 = useQuery2(__Query2, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery2.data,
    error = _useQuery2.error,
    loading = _useQuery2.loading;
  var _data_propertyCompare;
  var _ref = (_data_propertyCompare = data === null || data === void 0 ? void 0 : data.propertyCompare) !== null && _data_propertyCompare !== void 0 ? _data_propertyCompare : {},
    actionSheet = _ref.actionSheet,
    dialog = _ref.dialog;
  if (loading || error || !actionSheet || !dialog) {
    return null;
  }
  return /* @__PURE__ */React19.createElement(React19.Fragment, null, /* @__PURE__ */React19.createElement(LodgingCompareActionSheet, {
    data: actionSheet
  }), /* @__PURE__ */React19.createElement(LodgingCompareDialog, {
    data: dialog,
    inputs: inputs
  }));
};
PropertyCompare.displayName = "sharedui-PropertyCompare";
// src/components/compare/lodging-compare-state-manager.tsx
import React20, { useContext as useContext3, useEffect as useEffect3, useMemo as useMemo13, useRef as useRef3 } from "react";
import { useHistory, useLocation } from "react-router-dom";
import isEqual from "lodash.isequal";
import { COMPARE_PROPERTY_IDS_QUERY_PARAMETER, defaultState as defaultState3, INITIALIZE, RESET_PRESERVED, SET_PROPERTIES, STATE_FIELD_NAME as STATE_FIELD_NAME3 } from "@shared-ui/lodging-fragments";
import { useProvidedState as useProvidedState6 } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext as CompareAdaptExContext2 } from "@shared-ui/retail-compare-providers";
var parsePropertyIds = function (parameter) {
  return (parameter !== null && parameter !== void 0 ? parameter : "").split(",").filter(function (param) {
    var length = param.length;
    return length !== 0;
  });
};
var removeIgnoredFields = function (propertySearchCriteria) {
  var _propertySearchCriteria_secondary_selections, _propertySearchCriteria_secondary;
  var _propertySearchCriteria_secondary_selections_filter;
  return propertySearchCriteria && _object_spread_props(_object_spread({}, propertySearchCriteria), {
    primary: _object_spread_props(_object_spread({}, propertySearchCriteria === null || propertySearchCriteria === void 0 ? void 0 : propertySearchCriteria.primary), {
      destination: {}
    }),
    secondary: _object_spread_props(_object_spread({}, propertySearchCriteria === null || propertySearchCriteria === void 0 ? void 0 : propertySearchCriteria.secondary), {
      selections: (_propertySearchCriteria_secondary_selections_filter = propertySearchCriteria === null || propertySearchCriteria === void 0 ? void 0 : (_propertySearchCriteria_secondary = propertySearchCriteria.secondary) === null || _propertySearchCriteria_secondary === void 0 ? void 0 : (_propertySearchCriteria_secondary_selections = _propertySearchCriteria_secondary.selections) === null || _propertySearchCriteria_secondary_selections === void 0 ? void 0 : _propertySearchCriteria_secondary_selections.filter(function (param) {
        var id = param.id;
        return id !== "comparePropertyIds" && id !== "searchId";
      })) !== null && _propertySearchCriteria_secondary_selections_filter !== void 0 ? _propertySearchCriteria_secondary_selections_filter : [],
      counts: null
    })
  });
};
var shouldReset = function (propertySearchCriteria, previousPropertySearchCriteria) {
  var _propertySearchCriteria_primary_destination_mapBounds;
  return !isEqual(removeIgnoredFields(propertySearchCriteria), removeIgnoredFields(previousPropertySearchCriteria)) || !(propertySearchCriteria === null || propertySearchCriteria === void 0 ? void 0 : (_propertySearchCriteria_primary_destination_mapBounds = propertySearchCriteria.primary.destination.mapBounds) === null || _propertySearchCriteria_primary_destination_mapBounds === void 0 ? void 0 : _propertySearchCriteria_primary_destination_mapBounds.length) && !isEqual(propertySearchCriteria === null || propertySearchCriteria === void 0 ? void 0 : propertySearchCriteria.primary.destination, previousPropertySearchCriteria === null || previousPropertySearchCriteria === void 0 ? void 0 : previousPropertySearchCriteria.primary.destination);
};
var LodgingCompareStateManager = function (param) {
  var searchResultsProperties = param.searchResultsProperties,
    children = param.children;
  var _useProvidedState6 = _sliced_to_array(useProvidedState6(), 2),
    _useProvidedState6_ = _useProvidedState6[0],
    tmp = _useProvidedState6_[STATE_FIELD_NAME3],
    lodgingCompareState = tmp === void 0 ? defaultState3 : tmp,
    dispatch = _useProvidedState6[1];
  var _useContext3 = _sliced_to_array(useContext3(CompareAdaptExContext2), 1),
    propertySearchCriteria = _useContext3[0].propertySearchCriteria;
  var comparePropertyIds = lodgingCompareState.comparePropertyIds;
  var location = useLocation();
  var history = useHistory();
  var searchParams = useMemo13(function () {
    return new URLSearchParams(location.search);
  }, [location.search]);
  var propertyIdSearchParam = searchParams.get(COMPARE_PROPERTY_IDS_QUERY_PARAMETER);
  var initialPropertyIds = useMemo13(function () {
    return parsePropertyIds(propertyIdSearchParam);
  }, []);
  var initialized = useRef3(false);
  useEffect3(function () {
    initialized.current = true;
    if (initialPropertyIds.length) {
      dispatch({
        type: INITIALIZE,
        payload: {
          initialPropertyIds: initialPropertyIds,
          isDialogDeepLink: searchParams.get(DIALOG_KEY) === DIALOG_ID
        }
      });
    }
    return function () {
      if ("location" in history) {
        var _history_location = history.location,
          search = _history_location.search,
          pathname = _history_location.pathname,
          hash = _history_location.hash,
          state = _history_location.state;
        var params = new URLSearchParams(search);
        params.delete(COMPARE_PROPERTY_IDS_QUERY_PARAMETER);
        history.replace({
          pathname: pathname,
          hash: hash,
          search: params.toString(),
          state: state
        });
      }
    };
  }, []);
  useEffect3(function () {
    dispatch({
      type: SET_PROPERTIES,
      payload: {
        searchResultsProperties: searchResultsProperties
      }
    });
  }, [searchResultsProperties]);
  useEffect3(function () {
    if (comparePropertyIds.join(",") !== parsePropertyIds(propertyIdSearchParam).join(",")) {
      var params = new URLSearchParams(history.location.search);
      if (comparePropertyIds.length === 0) {
        params.delete(COMPARE_PROPERTY_IDS_QUERY_PARAMETER);
      } else {
        params.set(COMPARE_PROPERTY_IDS_QUERY_PARAMETER, comparePropertyIds.join(","));
      }
      history.replace({
        pathname: location.pathname,
        hash: location.hash,
        state: location.state,
        search: params.toString()
      });
    }
  }, [comparePropertyIds, propertyIdSearchParam]);
  var previousPropertySearchCriteria = useRef3(propertySearchCriteria);
  useEffect3(function () {
    if (shouldReset(propertySearchCriteria, previousPropertySearchCriteria.current)) {
      dispatch({
        type: RESET_PRESERVED
      });
    }
    previousPropertySearchCriteria.current = propertySearchCriteria;
  }, [propertySearchCriteria]);
  if (initialPropertyIds.length && !initialized.current) {
    return null;
  }
  return /* @__PURE__ */React20.createElement(React20.Fragment, null, children);
};
// src/components/compare/lodging-compare-state-chunk.ts
import { ADD_COMPARE_PROPERTY, CLOSE_DIALOG as CLOSE_DIALOG3, defaultState as defaultState4, events, getPropertyIdFromCardId as getPropertyIdFromCardId4, INITIALIZE as INITIALIZE2, OPEN_DIALOG as OPEN_DIALOG3, REMOVE_COMPARE_PROPERTY as REMOVE_COMPARE_PROPERTY3, RESET_PRESERVED as RESET_PRESERVED2, SET_PROPERTIES as SET_PROPERTIES2, STATE_FIELD_NAME as STATE_FIELD_NAME4 } from "@shared-ui/lodging-fragments";
// src/components/compare/utilities.ts
import { isAd as isAd3 } from "@shared-ui/lodging-fragments";
var getCardId = function (param) {
  var id = param.id,
    mediaSection = param.mediaSection;
  return isAd3(mediaSection) ? "".concat(id, "-ad") : id;
};
// src/components/compare/lodging-compare-state-chunk.ts
var selectPropertyIds = function (propertyIds, searchResultsProperties) {
  return _to_consumable_array(new Set(propertyIds.filter(function (id) {
    return searchResultsProperties.some(function (card) {
      return id === getCardId(card);
    });
  })));
};
var preserveSelectedProperties = function (propertyIds, searchResultsProperties) {
  return propertyIds.map(function (selectedId) {
    return searchResultsProperties.find(function (card) {
      return getCardId(card) === selectedId;
    });
  }).filter(function (maybeCard) {
    return Boolean(maybeCard);
  });
};
var update = function (event, state, eventData) {
  switch (event) {
    case SET_PROPERTIES2:
      {
        var searchResultsProperties = eventData.data.searchResultsProperties;
        var reselectPropertyIds = state.reselectPropertyIds,
          comparePropertyIds = state.comparePropertyIds,
          previousSearchResults = state.searchResultsProperties,
          previousPreservedProperties = state.preservedProperties;
        var preservedProperties = preserveSelectedProperties(comparePropertyIds, _to_consumable_array(previousPreservedProperties).concat(_to_consumable_array(previousSearchResults)));
        return _object_spread_props(_object_spread({}, state), {
          preservedProperties: preservedProperties,
          searchResultsProperties: searchResultsProperties,
          comparePropertyIds: reselectPropertyIds.length ? selectPropertyIds(reselectPropertyIds, _to_consumable_array(preservedProperties).concat(_to_consumable_array(searchResultsProperties))) : comparePropertyIds
        });
      }
    case ADD_COMPARE_PROPERTY:
      {
        var propertyId = eventData.data.propertyId;
        return _object_spread_props(_object_spread({}, state), {
          comparePropertyIds: _to_consumable_array(state.comparePropertyIds).concat([propertyId]),
          reselectPropertyIds: defaultState4.reselectPropertyIds
        });
      }
    case REMOVE_COMPARE_PROPERTY3:
      {
        var propertyId1 = getPropertyIdFromCardId4(eventData.data.propertyId);
        var comparePropertyIds1 = state.comparePropertyIds.filter(function (id) {
          return getPropertyIdFromCardId4(id) !== propertyId1;
        });
        var deepLinkDialogPropertyIds = state.deepLinkDialogPropertyIds;
        return _object_spread_props(_object_spread({}, state), {
          comparePropertyIds: comparePropertyIds1,
          isDialogOpen: state.isDialogOpen ? comparePropertyIds1.length > 1 : state.isDialogOpen,
          reselectPropertyIds: defaultState4.reselectPropertyIds,
          deepLinkDialogPropertyIds: deepLinkDialogPropertyIds.length ? deepLinkDialogPropertyIds.filter(function (id) {
            return getPropertyIdFromCardId4(id) !== propertyId1;
          }) : deepLinkDialogPropertyIds
        });
      }
    case OPEN_DIALOG3:
      return _object_spread_props(_object_spread({}, state), {
        isDialogOpen: true
      });
    case CLOSE_DIALOG3:
      return _object_spread_props(_object_spread({}, state), {
        isDialogOpen: false,
        deepLinkDialogPropertyIds: defaultState4.deepLinkDialogPropertyIds
      });
    case INITIALIZE2:
      {
        var _eventData_data = eventData.data,
          initialPropertyIds = _eventData_data.initialPropertyIds,
          isDialogDeepLink = _eventData_data.isDialogDeepLink;
        return _object_spread_props(_object_spread({}, state), {
          reselectPropertyIds: initialPropertyIds,
          deepLinkDialogPropertyIds: isDialogDeepLink ? initialPropertyIds : defaultState4.deepLinkDialogPropertyIds
        });
      }
    case RESET_PRESERVED2:
      {
        return _object_spread_props(_object_spread({}, state), {
          comparePropertyIds: defaultState4.comparePropertyIds,
          preservedProperties: defaultState4.preservedProperties,
          reselectPropertyIds: defaultState4.reselectPropertyIds
        });
      }
    default:
      return state;
  }
};
var LodgingCompareStateChunk = {
  data: defaultState4,
  stateFieldName: STATE_FIELD_NAME4,
  events: events,
  update: update
};
// src/components/compare/index.tsx
import React21 from "react";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { errorBoundary, gate } from "@shared-ui/lodging-fragments";
import { ProductType, useProductType } from "@shared-ui/retail-product-type-providers";
var LodgingCompare = function (param) {
  var searchResultsProperties = param.searchResultsProperties,
    criteria = param.criteria,
    shoppingContext = param.shoppingContext,
    skipSsr = param.skipSsr;
  return /* @__PURE__ */React21.createElement(LodgingCompareStateManager, {
    searchResultsProperties: searchResultsProperties
  }, /* @__PURE__ */React21.createElement(PropertyCompare, {
    skipSsr: skipSsr,
    inputs: {
      criteria: criteria,
      shoppingContext: shoppingContext
    }
  }));
};
var useIsInExperiments = function () {
  var _useExperiment2_exposure = useExperiment2(M1_EXPERIMENT).exposure,
    m1Bucket = _useExperiment2_exposure.bucket;
  var _useExperiment2_exposure1 = useExperiment2(VRBO_X_VECTOR_WEB).exposure,
    vrboXVectorWebBucket = _useExperiment2_exposure1.bucket;
  return m1Bucket === 1 || m1Bucket === 2 || vrboXVectorWebBucket === 1 || vrboXVectorWebBucket === 2;
};
var productTypes = /* @__PURE__ */new Set([ProductType.Lodging]);
var useIsInProductTypes = function () {
  return productTypes.has(useProductType());
};
var gateByExperiments = gate({
  name: "gateByExperiments",
  predicate: useIsInExperiments
});
var gateByProductTypes = gate({
  name: "gateByProductType",
  predicate: useIsInProductTypes
});
var wrapInErrorBoundary = errorBoundary({
  label: "LodgingCompare"
});
var WrappedLodgingCompare = wrapInErrorBoundary(gateByProductTypes(gateByExperiments(LodgingCompare)));
export { WrappedLodgingCompare as LodgingCompare, LodgingCompareStateChunk, LodgingCompareStateManager, PropertyCompare, __Query2 as propertyCompareQuery }; /* istanbul ignore else -- @preserve */